<template lang="html">
    <div class="page" id="credits">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Credits</h2>
                <ul class="links">
                    <li>
                        <router-link
                            class="cancel"
                            :to="{ name: 'proPlayer', params: { id: $route.params.id } }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <span class="info large" style="margin-bottom: 10px"
                >{{ user.first_name }} {{ user.last_name }}</span
            >

            <empty-placeholder class="mt30" v-if="user && Object.keys(user.credits).length == 0">
                TIP: Players can purchase lesson credits within their own account. To add them
                manually tap the button below. Be aware Players will NOT be charged for manually
                added credits.
            </empty-placeholder>

            <div
                class="box"
                v-if="user && user.credits && Object.keys(user.credits).length"
                style="padding-bottom: 10px"
            >
                <div v-for="(credit, expiry) in user.credits" :key="credit.id" class="creditBox">
                    <p>{{ credit.length }} Lesson {{ "credit" | pluralize(credit.length) }}</p>
                    <span class="info">Valid untill {{ $date(expiry).format("D MMM YYYY") }}</span>
                </div>
            </div>

            <div v-else class="box">
                <span>{{ user.first_name }} has no credits</span>
            </div>

            <button
                @click.prevent="creditsOpen = true"
                class="button dark mb10 left"
                type="button"
                name="button"
                v-show="!creditsOpen"
            >
                Add Lesson credits
                <plus-icon class="icon" />
            </button>

            <form class="form3" v-show="creditsOpen">
                <div class="formGroup">
                    <select :disabled="form.busy" v-model="form.credits" style="background: white">
                        <option v-for="n in 20" :key="n" :value="n">
                            Add {{ n }} {{ "credit" | pluralize(n) }}
                        </option>
                    </select>
                    <has-error :form="form" field="credits" />
                    <has-error :form="form" field="price" />
                </div>
                <div class="formGroup">
                    <button
                        :disabled="form.busy"
                        @click.prevent="buyCredits"
                        class="button"
                        type="button"
                        name="button"
                    >
                        {{ form.busy ? "Please wait..." : "Confirm" }}
                    </button>
                </div>
            </form>

            <empty-placeholder class="mt30 warning">
                IMPORTANT: Unused lesson credits will expire 12 months after purchase. A reminder
                will automatically be sent to Players 1 month before the date of expiry.
            </empty-placeholder>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import { Form, HasError } from "vform";
import { XIcon, PlusIcon } from "vue-feather-icons";
export default {
    name: "credits",
    components: { EmptyPlaceholder, HasError, FadeImage, XIcon, PlusIcon },
    created() {
        this.getUser();
    },
    data() {
        return {
            user: false,
            creditsOpen: false,
            form: new Form({
                credits: 1,
                price: "",
                player_id: false,
                payment_made: false,
            }),
        };
    },
    methods: {
        getUser() {
            this.form.get("/user/" + this.$route.params.id).then((response) => {
                this.user = response.data;
            });
        },
        buyCredits() {
            this.form.player_id = this.$route.params.id;

            this.form.post("/credits").then((response) => {
                this.user.credits = response.data;
                this.creditsOpen = false;
                this.form.credits = 1;
                this.$notify("Credits added");
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#credits {
    .box {
        background: white;
        border-radius: $radius;
        padding: 20px;
        color: $green_0;
        margin-bottom: 30px;

        p {
            margin-bottom: 10px;
        }
    }
    .form3 {
        input[type="number"] {
            text-align: center;
        }
        .button {
            position: relative;
            .icon {
                position: absolute;
                right: 15px;
                top: 15px;
                width: 18px;
            }
        }
    }
}
</style>
